export { default } from "./InputTransparent";
